import React, { useState } from 'react';
import withLayout from '../../../hocs/Layout';
import { FormProvider, RHFFileField } from '../../../common/hook-form';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { Box } from '@mui/system';
import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { apiConstants, postMultipart } from '../../../common/constants';
import { toast } from "react-toastify";
import { Button, Typography } from '@mui/material';
import { DownloadOutlined, UploadFileOutlined } from '@mui/icons-material';
import PageTitle from '../../../common/PageTitle';
import LabelDownloadBulkB2B from './LabelB2BDownload';
import { pageContainerSx, primaryBtnSx, secondaryBtnSx } from '../../../styles/patterns';
import { FONT, SIZE, WEIGHT } from '../../../styles/foundation/typography';
import { WHITE, BORDER, WARNING, NAVY } from '../../../styles/foundation/colors';
import { SHADOW } from '../../../styles/foundation/effects';

const BulkDownloadLabelsB2B = () => {
    const methodsBulkUpload = useForm({
        resolver: yupResolver(Yup.object().shape({
            orderFile: Yup.mixed().required("Please Select a File"),
        })),
        defaultValues: {
            orderFile: null
        }
    });
    const { handleSubmit: handleSubmitBulkUpload, reset } = methodsBulkUpload;
    const [fileLink, setFileLink] = useState([])
    const [isUploadingFile, setIsUploadingFile] = useState(false)
    const [zipLink, setZipLink] = useState([])
    const [mergedPdf, setMergedPdf] = useState([])

    const onSubmitBulkUpload = async (data) => {
        setIsUploadingFile(true)
        try {
            let form = new FormData()
            form.append('file', data.orderFile[0])
            await postMultipart(`${apiConstants.BULK_DOWNLOAD_LABELS}?shipmentType=B2B`, form).then(response => {
                if (response.data && response.data['excel'] && response.data['excel'].startsWith('https')) {
                    setFileLink(response.data['excel']);
                    setZipLink(response.data['zipFile'])
                    setMergedPdf(response.data['mergedPdf'])
                    toast("Successfully Uploaded!", { type: 'success' })
                    reset({
                        orderFile: null
                    })
                }
                else {
                    toast(response?.data[3962], { type: 'error' })
                }
            }).catch(err => { console.error(err); setIsUploadingFile(false); toast(err?.response?.data?.message || "Error uploading file", { type: 'error' }) });
        } catch (err) {
            const message = err?.response?.data?.message || err.message
            toast(message || "Error uploading file", { type: 'error' })
        }

        setIsUploadingFile(false)
    }

    return (
        <Box sx={pageContainerSx}>
            <PageTitle subTitle="Download shipping labels for your B2B shipments in bulk">Download Labels (B2B)</PageTitle>
            <div id="main-content" className="container-fluid">
                <Box sx={{ bgcolor: WHITE, border: '1px solid ' + BORDER, borderRadius: '12px', p: 3 }}>
                    <LabelDownloadBulkB2B />
                    <Box sx={{ mt: 2 }} />
                    <FormProvider methods={methodsBulkUpload} onSubmit={handleSubmitBulkUpload(onSubmitBulkUpload)}>
                        <RHFFileField name="orderFile" accept={['xlsx']} />
                        <Box sx={{ my: 2 }} />
                        <LoadingButton
                            startIcon={<FileUploadIcon />}
                            type="submit"
                            loading={isUploadingFile}
                            variant="contained"
                            sx={primaryBtnSx}
                            size="medium">
                            Upload
                        </LoadingButton>
                        {fileLink?.length === 0 &&
                            <Button variant="outlined" sx={{ ...secondaryBtnSx, ml: 2, textDecoration: 'none' }} href={"https://djslb35m04okm.cloudfront.net/generate_labels.csv"}
                                download="Order Upload Sample"
                                size="small"
                                startIcon={<UploadFileOutlined style={{ fontSize: 22 }} />}
                            >
                                Sample Download
                            </Button>
                        }
                        {fileLink?.length > 0 &&
                            <Button variant="outlined" sx={{ ...secondaryBtnSx, ml: 2, textDecoration: 'none' }} href={fileLink}
                                download="Download Excel"
                                size="small"
                                startIcon={<DownloadOutlined style={{ fontSize: 22 }} />}
                            >
                                Download Excel
                            </Button>

                        }
                        {zipLink?.length > 0 &&
                            <Button variant="outlined" sx={{ ...secondaryBtnSx, ml: 2, textDecoration: 'none' }} href={zipLink}
                                download="Download Zip"
                                size="small"
                                startIcon={<DownloadOutlined style={{ fontSize: 22 }} />}
                            >
                                Download Zip
                            </Button>
                        }
                        {mergedPdf?.length > 0 &&
                            <Button variant="outlined" sx={{ ...secondaryBtnSx, ml: 2, textDecoration: 'none' }} href={mergedPdf}
                                download="Download PDF"
                                target="_blank"
                                size="small"
                                startIcon={<DownloadOutlined style={{ fontSize: 22 }} />}
                            >
                                Download Merged PDF
                            </Button>
                        }
                        <Typography component='span' color='error' variant='body1'> You can only upload up to 500 AWBs at once.</Typography>
                    </FormProvider>
                </Box>
            </div>
        </Box>
    )
}
export default withLayout(BulkDownloadLabelsB2B);
